var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 17.7525L6.43769 20.119L6.96958 14.0976L3 9.53888L8.89103 8.18403L12 3L15.109 8.18403L21 9.53888L17.0304 14.0976L17.5623 20.119L12 17.7525Z' fill='%23FFA940'/%3e%3c/svg%3e";
  var StarColored = img;

export { StarColored as default };
